import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useOrganization } from 'hooks/useOrganization'
import { PaginatedDropdown } from 'components'
import uuid from 'uuid/v4'

const OrganizationPicker = (
  { 
    filter,
    searchOnEnter,
    showRightIcon = false,
    ...props 
  }, 
  ref
) => {
    const [filteredOrgs, setFilteredOrgs] = useState([])
    const {
      dataOrganizations: orgs,
      getOrganizations,
      loadingOrganizations,
    } = useOrganization()
    const localRef = useRef()
    const widgetRef = ref || localRef

    const fetchOptions = useCallback(
      ({ term: globalSearch, ...rest }) => getOrganizations({ globalSearch, ...rest }),
      [getOrganizations],
    )

    useEffect(() => {
      if (orgs) {
        setFilteredOrgs(filter ? orgs?.data?.filter(filter) : orgs?.data)
      }
    }, [orgs])

    const addCustomValue = (value) => {
      const items = [...widgetRef.current.state.selected, value]
      if (props.multiple) {
        widgetRef.current.state.selected = items
        widgetRef.current.state.text = ''
      }
      props.onChange(items, widgetRef)
      widgetRef.current.hideMenu()
    }
  
    const searchProps = searchOnEnter
      ? {
          onKeyDown({ keyCode, target: { value } }) {
            if (keyCode === 13) {
               // Enter key pressed
              addCustomValue(value)
            }
          },
        }
      : {}

    const handleIconClick = (value) => {
      addCustomValue(value)
      widgetRef.current.hideMenu()
    }

    return (
      <PaginatedDropdown
        id="organization-picker"
        isLoading={loadingOrganizations}
        source={filteredOrgs}
        placeholder="Search by Organization"
        labelKey="name"
        filterBy={() => true} // Disable local filtering
        {...searchProps}        
        ref={widgetRef}
        handleIconClick={handleIconClick}
        showRightIcon={showRightIcon}
        {...{ fetchOptions, ...props }}
      />
    )
}

export default React.forwardRef(OrganizationPicker)
